import ChunkErrorFallback from '../components/chunkErrorFallback';
import lazyWithLogging from './lazyWithLogging';

const lazyWithChunkErrorFallback = <
  T extends { default: React.ComponentType<any> }
>(
  factory: () => Promise<T>
): (() => Promise<T>) => lazyWithLogging(factory, ChunkErrorFallback);

export default lazyWithChunkErrorFallback;
